import axiosInstance from '@/api/axiosInstance';

const getUserScopedValsAPI = async () => {
    let url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/key-store?is-user-scope=true`;
    return await axiosInstance.get(url);
};
const getGlobalScopedValsAPI = async () => {
    let url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/key-store?is-user-scope=false`;
    return await axiosInstance.get(url);
};
const updateRecentsAPI = async (body) => {
    let url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/key-store`;
    return await axiosInstance.put(url, body);
};

export default {
    getUserScopedValsAPI,
    getGlobalScopedValsAPI,
    updateRecentsAPI,
};
